/* iBrushy rebuild 2026-10 (L1, owner F3): behaviour of every offer block rendered by snippets/ib-offer-*.liquid.
   Public API below is stable; other workers use this file read-only and ask the lead for changes.
   Init: <script src="ib-offer.js" defer>, any number of times per page (guarded by window.ibOffer). Clicks, keys and changes are
     delegated from document, so a block needs no per-instance init; sticky bars and [data-ib-timer="midnight"|"m17"] start at load.
   Markup contract:
     root     [data-ib-offer]  data-ib-name = timer key, data-product-id = sticky ATC target.
     tier     .ib-offer__bars > .ib-offer__bar[data-ib-variant-id][data-ib-qty], selected = .ib-offer__bar--selected (optional child
              radio). Tier -> one line {id: data-ib-variant-id, quantity: data-ib-qty}. Per-unit pick (cream): swatch dropdowns
              .ib-offer__bar-variants .ib-offer__swatch-dropdown[data-value] in the bar + template[data-ib-offer-options] mapping
              [data-value] -> [data-ib-variant-id]; quantity is split evenly over the dropdowns.
     add-on   [data-ib-upsell][data-ib-variant-id], click toggles .ib-offer__bar--selected, adds quantity 1 when selected and not hidden.
              [data-ib-once] (Bag Cotone): hidden once the cart has it (or the id in data-ib-once), shown again when a full cart lacks it.
     list     [data-ib-list="<tier index>"] is shown for the selected tier only (body).
     property select[data-ib-prop="<name>"] in the visible list: a non-empty value becomes properties {name: value} on the tier line
              (body cream fragrance, read by assets/ib2-kit-guard.js).
     gift     [data-ib-gift="locked|unlocked"], unlocked shown when the tier quantity is >= 2.
   API: window.ibOffer.items(root) -> [{id: Number, quantity: Number, properties?}] = the ATC payload items (same ids merged);
        window.ibOffer.selectBar(tierEl); event 'ib:offer:change' {detail: {items}} bubbles from the root on tier/swatch change.
   ATC: the host posts {items: ibOffer.items(root)} to /cart/add.js (assets/ib2-product.js via window.ibCart.add, assets/ib-pdp.js).
   No discount or gift logic here: kits are the guard's job (assets/ib2-kit-guard.js). */
(() => {
  if (window.ibOffer) return;
  const P = 'ib-offer__';
  const CHECK = '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.334 1 5 8.333 1.667 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  const bundleOf = (el) => el.closest('[data-ib-offer]');
  const barsOf = (b) => [...b.querySelectorAll('.' + P + 'bars > .' + P + 'bar')];
  const selectedBar = (b) => b.querySelector('.' + P + 'bars > .' + P + 'bar--selected');

  function selectBar(bar) {
    const b = bundleOf(bar);
    const root = b.querySelector('.ib-offer');
    if (root) root.removeAttribute('data-ib-variants-all');
    for (const x of barsOf(b)) {
      const on = x === bar;
      x.classList.toggle(P + 'bar--selected', on);
      const r = x.querySelector(':scope > input[type="radio"]');
      if (r) r.checked = on;
    }
    const qty = +bar.dataset.ibQty || 1;
    for (const g of b.querySelectorAll('[data-ib-gift]')) g.hidden = (g.dataset.ibGift === 'unlocked') !== qty >= 2;
    const i = String(barsOf(b).indexOf(bar));
    for (const l of b.querySelectorAll('[data-ib-list]')) l.hidden = l.dataset.ibList !== i;
    b.dispatchEvent(new CustomEvent('ib:offer:change', { bubbles: true, detail: { items: items(b) } }));
  }

  function toggleUpsell(up) {
    const on = !up.classList.contains(P + 'bar--selected');
    up.classList.toggle(P + 'bar--selected', on);
    const main = up.querySelector('.' + P + 'bar-main');
    if (main) main.setAttribute('aria-checked', on ? 'true' : 'false');
    const box = up.querySelector('.' + P + 'checkbox-upsells__checkbox');
    if (box) {
      box.classList.toggle(P + 'checkbox-upsells__checkbox--selected', on);
      box.innerHTML = on ? CHECK : '';
    }
  }

  // per-unit variant ids from the selects inside the selected bar (cream), else the bar's variant x qty
  function items(b) {
    const out = new Map();
    const add = (id, q) => { if (id) out.set(String(id), (out.get(String(id)) || 0) + q); };
    const bar = selectedBar(b);
    if (bar) {
      const sels = [...bar.querySelectorAll('.' + P + 'bar-variants .' + P + 'swatch-dropdown')];
      const map = optionMap(b);
      if (sels.length && map) {
        const qty = +bar.dataset.ibQty || 1;
        sels.forEach((s) => add(map[s.dataset.value] || bar.dataset.ibVariantId, qty / sels.length));
      } else add(bar.dataset.ibVariantId, +bar.dataset.ibQty || 1);
    }
    for (const up of b.querySelectorAll('[data-ib-upsell].' + P + 'bar--selected:not([hidden])')) add(up.dataset.ibVariantId, 1);
    const props = {};
    for (const s of b.querySelectorAll('[data-ib-list]:not([hidden]) select[data-ib-prop]')) if (s.value) props[s.dataset.ibProp] = s.value;
    const kit = bar && String(bar.dataset.ibVariantId);
    return [...out].map(([id, quantity]) => (id === kit && Object.keys(props).length ? { id: +id, quantity, properties: props } : { id: +id, quantity }));
  }

  function optionMap(b) {
    const t = b.querySelector('template[data-ib-offer-options]');
    if (!t) return null;
    const m = {};
    for (const o of t.content.querySelectorAll('[data-value]')) m[o.dataset.value] = o.dataset.ibVariantId;
    return m;
  }

  function updateCreamRow(sel) {
    const row = sel.closest('[data-ib-list]')?.querySelector('[data-ib-cream-row]');
    if (!row) return;
    const flavor = sel.value === 'Ocean' ? 'ibCreamOcean' : 'ibCreamVanilla';
    const img = row.querySelector('.ibb__ic');
    if (img) {
      const src = img.dataset[flavor + 'Src'];
      const srcset = img.dataset[flavor + 'Srcset'];
      if (src) img.src = src;
      if (srcset) img.srcset = srcset;
      else if (src) img.removeAttribute('srcset');
    }
    row.dataset.ibVariantId = row.dataset[flavor + 'Id'] || '';
    const price = row.querySelector('[data-ib-row-price]');
    if (price && row.dataset[flavor + 'Price']) price.textContent = row.dataset[flavor + 'Price'];
    const compare = row.querySelector('[data-ib-row-compare]');
    if (compare) {
      const value = row.dataset[flavor + 'Compare'] || '';
      compare.textContent = value;
      compare.hidden = !value;
    }
  }

  // swatch dropdown: listbox appended to body, fixed under the select (as live)
  let open = null;
  function closeDropdown() {
    if (!open) return;
    open.list.remove();
    open.sel.setAttribute('aria-expanded', 'false');
    open = null;
  }
  function openDropdown(sel) {
    const b = bundleOf(sel);
    const t = b && b.querySelector('template[data-ib-offer-options]');
    if (!t) return;
    closeDropdown();
    const wrap = sel.closest('.' + P + 'swatch-dropdown');
    const list = document.createElement('div');
    list.className = P + 'swatch-dropdown__options';
    list.setAttribute('role', 'listbox');
    list.id = sel.getAttribute('aria-controls') || '';
    list.append(t.content.cloneNode(true));
    [...list.children].forEach((o, i) => {
      const on = o.dataset.value === wrap.dataset.value;
      o.id = list.id + '-option-' + i;
      o.setAttribute('aria-selected', on ? 'true' : 'false');
      o.classList.toggle(P + 'swatch-dropdown__option--focused', on);
    });
    const r = sel.getBoundingClientRect();
    list.style.left = r.left + 'px';
    list.style.top = r.bottom + 'px';
    document.body.append(list);
    sel.setAttribute('aria-expanded', 'true');
    open = { sel, wrap, list };
  }
  function pick(opt) {
    const { sel, wrap } = open;
    wrap.dataset.value = opt.dataset.value;
    const sw = sel.querySelector('.' + P + 'swatch');
    if (sw) {
      sw.style.setProperty('--ib-offer-swatch-color', opt.dataset.sw);
      sw.style.setProperty('--ib-offer-swatch-border-color', opt.dataset.bd);
    }
    const label = sel.querySelector(':scope > span');
    if (label) label.textContent = opt.dataset.value;
    closeDropdown();
    const b = bundleOf(wrap);
    if (b) b.dispatchEvent(new CustomEvent('ib:offer:change', { bubbles: true, detail: { items: items(b) } }));
  }

  // timers: 'midnight' = hh:mm:ss to local midnight, 'm17' = 17 minute countdown (mm:ss) restarting at 0
  const pad = (n) => String(n).padStart(2, '0');
  function tick() {
    const now = Date.now();
    for (const el of document.querySelectorAll('[data-ib-timer]')) {
      let s;
      if (el.dataset.ibTimer === 'midnight') {
        const m = new Date(); m.setHours(24, 0, 0, 0);
        s = Math.max(0, Math.floor((m - now) / 1000));
        el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
      } else {
        const key = 'ib-offer-timer-' + (bundleOf(el) || {}).dataset?.ibName;
        let start = +sessionStorage.getItem(key);
        if (!start || now - start >= 17 * 60000) { start = now; try { sessionStorage.setItem(key, String(now)); } catch (e) {} }
        s = Math.max(0, Math.ceil((17 * 60000 - (now - start)) / 1000) - 1);
        el.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
      }
    }
  }

  document.addEventListener('change', (e) => {
    const r = e.target;
    if (r.matches && r.matches('[data-ib-offer] select[data-ib-prop]')) {
      updateCreamRow(r);
      return;
    }
    if (r.matches && r.matches('[data-ib-offer] .' + P + 'bars > .' + P + 'bar > input[type="radio"]') && r.checked) selectBar(r.parentElement);
  });
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (open) {
      const opt = t.closest('.' + P + 'swatch-dropdown__option');
      if (opt && open.list.contains(opt)) { e.preventDefault(); pick(opt); return; }
      const same = t.closest('.' + P + 'bar-variant-select') === open.sel;
      closeDropdown();
      if (same) { e.preventDefault(); return; }
    }
    if (!bundleOf(t)) return;
    const sel = t.closest('.' + P + 'bar-variant-select');
    if (sel) { e.preventDefault(); e.stopPropagation(); openDropdown(sel); return; }
    const up = t.closest('[data-ib-upsell]');
    if (up) { e.preventDefault(); toggleUpsell(up); return; }
    const bar = t.closest('.' + P + 'bars > .' + P + 'bar');
    if (bar && !bar.classList.contains(P + 'bar--selected') && !t.closest('label')) selectBar(bar);
  }, true);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') return closeDropdown();
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const t = e.target;
    if (!bundleOf(t) || !t.matches('[role="button"],[role="checkbox"],[role="combobox"]')) return;
    e.preventDefault();
    t.click();
  });
  window.addEventListener('scroll', closeDropdown, { passive: true });
  window.addEventListener('resize', closeDropdown);

  // sticky add-to-cart bar (cream, glove), as live Kaching: wrapper moved to the end of body, shown while the offer block is
  // entirely above the viewport (block bottom < 0), hidden otherwise; the spacer keeps the page end clear while it shows.
  // Click = smooth scroll back to the offer block top - 100px, as live. data-ib-sticky-action="atc" clicks the section's main add to cart instead.
  function sticky(w) {
    const bundle = bundleOf(w), block = bundle.querySelector('ib-offer-block') || bundle;
    const host = w.querySelector('ib-offer-sticky-atc'), spacer = w.querySelector('.ib-offer-sticky-atc-spacer');
    const V = 'ib-offer-sticky-atc--visible';
    let t = 0;
    document.body.append(w);
    // scroll listener, not IntersectionObserver: a jump past the block (anchor, restore, fling) never crosses an IO threshold
    const update = () => {
      const on = block.getBoundingClientRect().bottom < 0;
      if (on === host.classList.contains(V)) return;
      clearTimeout(t);
      if (on) {
        host.style.display = 'block';
        spacer.style.height = host.offsetHeight + 'px'; // reading offsetHeight also flushes layout, so the slide-in transition runs
        host.classList.add(V);
      } else {
        host.classList.remove(V);
        t = setTimeout(() => { host.style.display = ''; spacer.style.height = '0px'; }, 100);
      }
    };
    addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    // keep the spacer equal to the bar while it shows (image arriving late, title wrapping on resize)
    new ResizeObserver(() => { if (host.classList.contains(V)) spacer.style.height = host.offsetHeight + 'px'; }).observe(host);
    update();
    host.querySelector('button').addEventListener('click', () => {
      if (host.dataset.ibStickyAction === 'atc') {
        const sec = bundle.closest('.__ibp');
        const atc = sec && sec.querySelector(`[data-ibp-action-type^="add-to"][data-ibp-action-id="${bundle.dataset.productId}"]`);
        if (atc) return atc.click();
      }
      scrollTo({ top: block.getBoundingClientRect().top + scrollY - 100, behavior: 'smooth' });
    });
  }
  document.querySelectorAll('[data-ib-offer] .ib-offer-sticky-atc-wrapper').forEach(sticky);

  // [data-ib-once] upsells (Bag Cotone) are never offered twice. An add response lists only the added lines (hide on match);
  // a full cart (item_count present: get, change, update, clear) also shows them again once the line is gone.
  document.addEventListener('ib:cart:updated', (e) => {
    const data = e.detail && e.detail.data;
    if (!data || !Array.isArray(data.items)) return;
    const ids = new Set(data.items.map((l) => String(l.variant_id || l.id)));
    const full = typeof data.item_count === 'number';
    for (const up of document.querySelectorAll('[data-ib-offer] [data-ib-once]')) {
      // a non-empty data-ib-once = the hidden copy the kit guard turns this variant into (13/10): either id in the cart counts
      if (ids.has(up.dataset.ibVariantId) || (up.dataset.ibOnce && ids.has(up.dataset.ibOnce))) up.hidden = true;
      else if (full) up.hidden = false;
    }
  });

  window.ibOffer = { items, selectBar };
  tick();
  setInterval(tick, 1000);
})();
